import React from "react";

const GetCDNURL = async () => {
    let cdnBaseUrl = await (await fetch('/auth/GetBlobCDNURL')).json();
    return cdnBaseUrl;
};

export default GetCDNURL;